/**
 * @desc 获取物流分组
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.LogisticsGroupResponseDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/basicData/getLogisticsGroup`, {
      method: "GET",

      ...options,
    }),
  );
}
